import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Box, SimpleGrid, Text } from "@mantine/core";
import AppSkeleton from "@modules/loader/AppSkeleton";
import dayjs from "dayjs";
import type ISkin from "../../shared/models/ISkin.model";

interface SkinDetailsGridProps {
  skin: ISkin | undefined;
}

export const SkinDetailsGrid = ({ skin }: SkinDetailsGridProps) => {
  const { t } = useAppTranslation("pages.skins.skin");

  const getInfoArea = (title: string, description: string) => (
    <Box className="gradient-primary-from-top h-[100px] space-y-3 rounded-xl p-6 text-primary-dark-text">
      <SSHeadline
        props={{
          stack: { align: "left" },
          title: {
            size: 15,
          },
        }}
      >
        <SSWhiteText>{title}</SSWhiteText>
      </SSHeadline>
      <AppSkeleton>
        <Text>{description}</Text>
      </AppSkeleton>
    </Box>
  );

  return (
    <SimpleGrid
      className="w-full"
      cols={{ base: 1, sm: 2, md: 4 }}
      spacing={30}
    >
      {getInfoArea(t("details.rarity"), `${skin?.rarity}`)}
      {getInfoArea(t("details.inGamePrice"), `${skin?.inGamePrice ?? 0} RP`)}
      {getInfoArea(
        t("details.releaseDate"),
        `${dayjs(skin?.releasedAt).format("DD MMMM YYYY")}`,
      )}
      {getInfoArea(t("details.chromas"), `${skin?.chromas}`)}
    </SimpleGrid>
  );
};
